import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

// 引入Font Awesome
import fontAwesome from './plugins/fontawesome'

// 引入Markdown预览组件（Vue 3版本）
import { MdPreview } from 'md-editor-v3'
import 'md-editor-v3/lib/style.css'

// 设置网页标题
document.title = 'AI职业规划'

const app = createApp(App)

// 注册所有Element Plus图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(router)
app.use(ElementPlus)
app.use(fontAwesome)
app.component('MdPreview', MdPreview)
app.mount('#app')
